
<template>
  <span class="meaning">
    <b-tab
      v-if="as !== 'plain'"
      v-bind:title="title"
      :title-link-class="tabClass"
    >
      <h5>
        <b-badge>中</b-badge>
        {{china}}
      </h5>
      <h5>
        <b-badge>台</b-badge>
        {{taiwan}}
      </h5>
      <h5>
        <b-badge>英</b-badge>
        {{english}}
      </h5>
    </b-tab>
    <template v-else-if="as === 'plain'">
      <h5>
        <b-badge>中</b-badge>
        {{china}}
      </h5>
      <h5>
        <b-badge>台</b-badge>
        {{taiwan}}
      </h5>
      <h5>
        <b-badge>英</b-badge>
        {{english}}
      </h5>
    </template>
  </span>
</template>

<script>
export default {
  name: "Meaning",
  props: {
    tabIndex: Number,
    taiwan: String,
    china: String,
    english: String,
    tabClass: Array,
    as: String
  },
  computed: {
    title: function() {
      return "異義" + (this.tabIndex >= 0 ? this.tabIndex + 1 : "");
    }
  },
  methods: {
    //v-bind:title-link-class="getTabClass()"
  }
};
</script>

<style scoped>
.meaning {
  font-family: "Noto Sans TC", "微軟正黑體";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>